import { useEffect, useRef, useState } from "react";
import SearchComponent from "../../components/SearchComponent";
import { ApiService } from "../../utils/ApiService";
import { showToast } from "../../common/Toast";
import { Avatar, formatDateTime } from "../../common/Functions";
import Pagination from "../../common/Pagination";
import { ChevronDown } from "lucide-react";
import UserTransactionTable from "../../components/Tables/UserTransactionTable";
import CustomRangePicker from "../../components/CustomeRangePicker/CustomRangePicker";
import FullPageLoader from "../../common/FullPageLoader";

const UserTransactions = () => {
    const [search, setSearch] = useState("");
    const [hostData, setHostData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedHost, setSelectedHost] = useState({});
    const [startingIndex, setStartingIndex] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalUser: 5,
    });
    const [transactions, setTransactions] = useState([]);
    const [showDatePicker, setShowDatePicker] = useState(false)
    const calendarRef = useRef(null);
    const inputRef = useRef(null);
    const filterRef = useRef(null)
    const [range,setRange] = useState({
        start: null,
        end: null
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showDatePicker &&
                filterRef.current &&
                !filterRef.current.contains(event.target)
            ) {
                setShowDatePicker(false);
            }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
    
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDatePicker]);


    const TransactionsData = [
    ]

    useEffect(() => {
        if (search) {
            console.log(search)
            const filtered = TransactionsData.filter((item) =>
                item.transactionsId?.toLowerCase().includes(search?.toLowerCase()) ||
                item.eventId?.toLowerCase().includes(search?.toLowerCase()) ||
                item.hostName?.toLowerCase().includes(search?.toLowerCase()))
            setFilteredData(filtered);
        } else {
            setFilteredData(TransactionsData);
        }
    }, [search]);

    const handlePagination = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            setPage(newPage);
        }
    }

    // useEffect(() => {
    //     setFilteredData(TransactionsData);
    // }, [])

    const fetchTransactionsList = async () => {
        try {
            const token = localStorage.getItem("auth_token")
            let res;
            if(range.start && range.end){
                res = await ApiService.get(
                    `admin/transaction-list?search=${search}&startDate=${range.start}&endDate=${range.end}`,
                    {},
                    {
                        headers: {
                            Authorization: `${token}`,
                        },
                    }
                );
            } else{
                res = await ApiService.get(
                    `admin/transaction-list?search=${search}`,
                    {},
                    {
                        headers: {
                            Authorization: `${token}`,
                        },
                    }
                );
            }

            // console.log("TRANSACTIONS LIST --> ", res)
            if(res.success){
                setTransactions(res.transactionList)
                setLoading(false)
            }
        } catch (error) {
            console.log("Error while fetching Transactions list --> ", error)
        }
    }

    useEffect(() => {
        fetchTransactionsList()
    }, [search, range])
    const handleDateChange = (e) => {
        // Example logic: setSearch('date:2025-11-24');
        setSearch(`date:${e.target.value}`);
    };

    const handleHostChange = (e) => {
        // Example logic: setSearch('host:John Doe');
        setSearch(`host:${e.target.value}`);
    };

    const handleEventIdChange = (e) => {
        // Example logic: setSearch('eventId:12345');
        setSearch(`eventId:${e.target.value}`);
    };

    const handleAttendeeChange = (e) => {
        // Example logic: setSearch('attendeeName:Jane Smith');
        setSearch(`attendeeName:${e.target.value}`);
    };

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearch(value)
    }

    const handleRangeChange = (newRange) => {
        setRange(newRange)
        if(page!==1){
          setPage(1);
        }
    }

    console.log("RANGE --> ", range)

    console.log("SEARCH TERM --> ", search)
    const FilterButton = () => {
        return (
            <div
                ref={inputRef}
                placeholder="MM/DD/YYYY - MM/DD/YYYY"
                onClick={() => setShowDatePicker(!showDatePicker)}
                value={range}
                // onChange={(e) => setDateRange(e.target.value)}
                className="w-full text-[11px] font-normal relative px-4 pr-10 rounded-full h-[40px] flex items-center border  bg-white appearance-none cursor-pointer hover:border-gray-300 transition-colors outline-0 text-[12px]"
              >
                {/* MM/DD/YYYY - MM/DD/YYYY */}
                {range.start && range.end 
                  ? `${range.start.toLocaleDateString()} - ${range.end.toLocaleDateString()}`
                  : "MM/DD/YYYY - MM/DD/YYYY"}
              <svg
                width="14"
                height="14"
                className="absolute right-3 top-[10px] pointer-events-none"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.66602 1.16667V2.91667"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.33398 1.16667V2.91667"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M2.04102 5.30249H11.9577"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12.25 4.95834V9.91667C12.25 11.6667 11.375 12.8333 9.33333 12.8333H4.66667C2.625 12.8333 1.75 11.6667 1.75 9.91667V4.95834C1.75 3.20834 2.625 2.04167 4.66667 2.04167H9.33333C11.375 2.04167 12.25 3.20834 12.25 4.95834Z"
                  stroke="#292D32"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.15565 7.99168H9.16089"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.15565 9.74168H9.16089"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.99732 7.99168H7.00256"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.99732 9.74168H7.00256"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.83924 7.99168H4.84448"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M4.83924 9.74168H4.84448"
                  stroke="#292D32"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              </div>
        );
    };

    return (
        <>
            {loading && <FullPageLoader />}
            <div className="flex-grow bg-gray-100  px-6 pb-2 w-full overflow-auto h-[90vh]">
                <div className="flex flex-row items-center mb-6 justify-between pr-2">
                    <SearchComponent search={search} onChange={handleSearch} placeholder="Search by transaction id, event id , host name" className="w-1/2" />
                    <div className= "relative w-[350px]" ref={filterRef}>
                        <FilterButton label="Date" />
                        {showDatePicker && (
                            <div ref={calendarRef}>
                            <CustomRangePicker
                                range={range}
                                onRangeChange={handleRangeChange}
                                onApply={() => setShowDatePicker(false)}
                                onCancel={() => {
                                setRange({ start: null, end: null });
                                setShowDatePicker(false);
                                }}
                            />
                            </div>
                        )}
                    </div>
                </div>
                    <UserTransactionTable filteredData={transactions} setSelectedHost={setSelectedHost}/>
                    <Pagination
                        page={page}
                        totalPages={pagination.totalPages}
                        totalItems={pagination.totalUser}
                        limit={limit}
                        onPageChange={(newPage) => handlePagination(newPage)}
                    />
                
            </div>
        </>
    )
}
export default UserTransactions;